import { useEffect } from 'react';

const useUnmountEffect = (callback: Function) => {
  useEffect(() => {
    return () => {
      callback();
    };
  }, [callback]);
};

export default useUnmountEffect;
